import { render, staticRenderFns } from "./usersTableOnCard.vue?vue&type=template&id=223f2ddd"
import script from "./usersTableOnCard.vue?vue&type=script&lang=js"
export * from "./usersTableOnCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports